import React, { useState } from 'react';
import { Form, Button, Col, Row, Card } from 'react-bootstrap';
import '../../App.css'; // Make sure to import your CSS file

function LotsForm() {
    const [lots, setLots] = useState({
        lot_code: '',
        notes: '',
        company_id: '',
        supplier_id: '',
    });

    const [compositions, setCompositions] = useState([
        { material_id: '', percentage: '', material_suppliers: [] },
    ]);

    const handleLotChange = (e) => {
        const { name, value } = e.target;
        setLots({ ...lots, [name]: value });
    };

    const handleCompositionChange = (index, e) => {
        const { name, value } = e.target;
        const newCompositions = [...compositions];
        newCompositions[index][name] = value;
        setCompositions(newCompositions);
    };

    const handleMaterialSupplierChange = (compIndex, matIndex, e) => {
        const { name, value } = e.target;
        const newCompositions = [...compositions];
        newCompositions[compIndex].material_suppliers[matIndex][name] = value;
        setCompositions(newCompositions);
    };

    const addComposition = () => {
        setCompositions([...compositions, { material_id: '', percentage: '', material_suppliers: [] }]);
    };

    const addMaterialSupplier = (compIndex) => {
        const newCompositions = [...compositions];
        newCompositions[compIndex].material_suppliers.push({
            name: '',
            country_id: '',
            transport_type: '',
        });
        setCompositions(newCompositions);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log('Lot:', lots);
        console.log('Compositions:', compositions);
    };

    return (
        <Form onSubmit={handleSubmit}>
            {/* Lot Information */}
            <Card className="mb-3">
                <Card.Header>Lot Information</Card.Header>
                <Card.Body>
                    <Row>
                        <Col>
                            <Form.Group controlId="lot_code">
                                <Form.Label>Lot Code</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="lot_code"
                                    value={lots.lot_code}
                                    onChange={handleLotChange}
                                    required
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group controlId="notes">
                                <Form.Label>Notes</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="notes"
                                    value={lots.notes}
                                    onChange={handleLotChange}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form.Group controlId="company_id">
                                <Form.Label>Company ID</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="company_id"
                                    value={lots.company_id}
                                    onChange={handleLotChange}
                                />
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group controlId="supplier_id">
                                <Form.Label>Supplier ID</Form.Label>
                                <Form.Control
                                    type="text"
                                    name="supplier_id"
                                    value={lots.supplier_id}
                                    onChange={handleLotChange}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            {/* Compositions Section */}
            {compositions.map((composition, compIndex) => (
                <Card key={compIndex} className="composition-section">
                    <Card.Header>Composition #{compIndex + 1}</Card.Header>
                    <Card.Body>
                        <Row>
                            <Col>
                                <Form.Group controlId={`material_id_${compIndex}`}>
                                    <Form.Label>Material ID</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="material_id"
                                        value={composition.material_id}
                                        onChange={(e) => handleCompositionChange(compIndex, e)}
                                        required
                                    />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group controlId={`percentage_${compIndex}`}>
                                    <Form.Label>Percentage</Form.Label>
                                    <Form.Control
                                        type="number"
                                        name="percentage"
                                        value={composition.percentage}
                                        onChange={(e) => handleCompositionChange(compIndex, e)}
                                        required
                                    />
                                </Form.Group>
                            </Col>
                        </Row>

                        {/* Material Suppliers Section */}
                        {composition.material_suppliers.map((supplier, matIndex) => (
                            <Card key={matIndex} className="mb-2">
                                <Card.Header>Material Supplier #{matIndex + 1}</Card.Header>
                                <Card.Body>
                                    <Row>
                                        <Col>
                                            <Form.Group controlId={`name_${matIndex}`}>
                                                <Form.Label>Supplier Name</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="name"
                                                    value={supplier.name}
                                                    onChange={(e) => handleMaterialSupplierChange(compIndex, matIndex, e)}
                                                    required
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group controlId={`country_id_${matIndex}`}>
                                                <Form.Label>Country ID</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="country_id"
                                                    value={supplier.country_id}
                                                    onChange={(e) => handleMaterialSupplierChange(compIndex, matIndex, e)}
                                                    required
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col>
                                            <Form.Group controlId={`transport_type_${matIndex}`}>
                                                <Form.Label>Transport Type</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="transport_type"
                                                    value={supplier.transport_type}
                                                    onChange={(e) => handleMaterialSupplierChange(compIndex, matIndex, e)}
                                                    required
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        ))}

                        <Button variant="secondary" onClick={() => addMaterialSupplier(compIndex)}>
                            Add Material Supplier
                        </Button>
                    </Card.Body>
                </Card>
            ))}

            <Button variant="primary" onClick={addComposition}>
                Add Composition
            </Button>

            <Button variant="success" type="submit" className="mt-3">
                Submit
            </Button>
        </Form>
    );
}

export default LotsForm;
